import React from 'react';
import { Alert } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { Role } from '../../types';
import { apiClient } from '../../services/api';

interface CompanyScopeBannerProps {
  companyId?: string;
}

const CompanyScopeBanner: React.FC<CompanyScopeBannerProps> = ({ companyId }) => {
  const { t } = useLanguage();
  const { user } = useAuth();
  const query = useQuery({
    queryKey: ['company-scope', companyId, user?.role, user?.companyId],
    queryFn: () => user?.role === Role.SUPER_ADMIN
      ? apiClient.getCompany(companyId!)
      : apiClient.getCurrentCompany(),
    enabled: Boolean(companyId && user),
    staleTime: 60_000,
  });

  if (!companyId) return null;
  return <Alert severity="info" sx={{ mb: 2 }}>{t('sales.companyScope')}: <strong>{query.data?.name || companyId}</strong></Alert>;
};

export default CompanyScopeBanner;
